import type {Theme} from '@wix/cashier-express-checkout-widget/dist/src/types/Styles';
import {isLightBackground} from '../../utils/colorContrast';

export interface BackgroundPalette {
  textColor: string;
  expressButtonsTheme: Theme;
  expressButtonsBorderColor: string;
  secondaryTextColor?: string;
}

const lightBackgroundPalette: BackgroundPalette = {
  textColor: '#000000',
  expressButtonsTheme: 'dark',
  expressButtonsBorderColor: '#D9DBDD',
  secondaryTextColor: undefined,
};

const darkBackgroundPalette: BackgroundPalette = {
  textColor: '#FFFFFF',
  expressButtonsTheme: 'light',
  expressButtonsBorderColor: '#858585',
  secondaryTextColor: '#858585',
};

export const getBackgroundPalette = (backgroundHex: string | undefined): BackgroundPalette | undefined => {
  const isLight = isLightBackground(backgroundHex);
  if (isLight === undefined) {
    return undefined;
  }

  return isLight ? lightBackgroundPalette : darkBackgroundPalette;
};
